<template>
  <v-tooltip top>
    <v-btn flat icon class="ml-1" slot="activator" v-on:click="$emit('click')">
      <v-avatar size="32px" class="bs avatar-bg">
        <v-icon>{{icon}}</v-icon>
      </v-avatar>
    </v-btn>
    <span>{{tip}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    icon: String,
    tip: String
  }
}
</script>
